import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/Icon_ThemeShowcase.png'
import _imports_1 from '../assets/WallCat_GPLAY_Guide_1.png'
import _imports_2 from '../assets/ThemeShowcase_GPLAY_Guide_2.jpg'
import _imports_3 from '../assets/ThemeShowcase_GPLAY_Guide_3.png'
import _imports_4 from '../assets/Screenshot_ThemeShowcase_1.png'
import _imports_5 from '../assets/Screenshot_ThemeShowcase_2.png'
import _imports_6 from '../assets/Screenshot_ThemeShowcase_3.png'
import _imports_7 from '../assets/Screenshot_ThemeShowcase_4.png'
import _imports_8 from '../assets/Screenshot_ThemeShowcase_5.png'
import _imports_9 from '../assets/Screenshot_ThemeShowcase_6.png'
import _imports_10 from '../assets/Screenshot_ThemeShowcase_7.png'
import _imports_11 from '../assets/Screenshot_ThemeShowcase_8.png'
import _imports_12 from '../assets/Screenshot_ThemeShowcase_9.png'
import _imports_13 from '../assets/Screenshot_ThemeShowcase_10.png'
import _imports_14 from '../assets/Screenshot_ThemeShowcase_11.png'
import _imports_15 from '../assets/Screenshot_ThemeShowcase_12.png'
import _imports_16 from '../assets/Screenshot_ThemeShowcase_13.png'
import _imports_17 from '../assets/Screenshot_ThemeShowcase_14.png'
import _imports_18 from '../assets/Screenshot_ThemeShowcase_15.png'
import _imports_19 from '../assets/Screenshot_ThemeShowcase_16.png'
import _imports_20 from '../assets/Screenshot_ThemeShowcase_17.png'
import _imports_21 from '../assets/Screenshot_ThemeShowcase_18.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_column = _resolveComponent("ion-column")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("ThemeShowcase", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("ThemeShowcase", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "column-standard2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "bannerColumn" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "auto" }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "icon"
                      }, null, -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "auto",
                    class: "description-column"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { style: {"padding":"0px","margin":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, { style: {"padding":"0px","margin":"0px"} }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createElementVNode("p", {
                                class: "size-appname",
                                style: {"padding":"0px","margin":"0px"}
                              }, [
                                _createElementVNode("strong", null, "ThemeShowcase")
                              ], -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, null, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createElementVNode("p", { class: "size-appname-icon" }, "version 1.0 (Beta 2)", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.logoAndroid,
                                class: "size-appname-icon"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        href: "https://f2.puffercat.xyz/PuffercatApps/ThemeShowcase-1.0b2.apk",
                        expand: "full",
                        shape: "round",
                        style: {"margin":"0px"},
                        download: "PufferIcons-latest.apk"
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("Download", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-extension" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        id: "alternateMirrors_ThemeShowcase",
                        expand: "full",
                        shape: "round",
                        style: {"margin":"0px"}
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("Alternate mirrors", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        id: "googlePlayEA_ThemeShowcase",
                        expand: "full",
                        shape: "round",
                        style: {"margin":"0px"}
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("Google Play", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_modal, {
                ref: "modal",
                trigger: "alternateMirrors_ThemeShowcase"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_title, null, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode("Alternate mirrors", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss()))
                              }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                  _createTextVNode("Close", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_content, { class: "ion-padding" }, {
                    default: _withCtx(() => [
                      _cache[46] || (_cache[46] = _createElementVNode("h2", { style: {"padding-left":"30px"} }, "ThemeShowcase 1.0 (Beta 2)", -1)),
                      _createVNode(_component_ion_label, {
                        color: "medium",
                        class: "tableLabel checksum",
                        style: {"padding-left":"30px"}
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("SHA256 Checksum: cb28eee022526c9745ebfe815060a090e59f5b48af15483afdd51e6b8c1b9f23", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_list, {
                        inset: true,
                        style: {"border-radius":"25px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                  _createElementVNode("a", { href: "https://f2.puffercat.xyz/PuffercatApps/ThemeShowcase-1.0b2.apk" }, "🇩🇪 2.puffercat.xyz - Contabo (Default)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                  _createElementVNode("a", { href: "https://cdn.puffercat.xyz/c/puffercat-apps/apks/ThemeShowcase/ThemeShowcase-1.0b2.apk" }, "🇳🇱 puffercat.xyz - DigitalOcean", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                  _createElementVNode("a", { href: "https://deimos.pufferc.at/mirror/ThemeShowcase-1.0b2.apk" }, "🇸🇪 deimos.pufferc.at - aeza", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                  _createElementVNode("a", { href: "https://c.wadowice.ovh/index.php/s/themeshowcase1b2" }, "🇵🇱 wadowice.ovh - My home (pls dont ddos 🥺)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                  _createElementVNode("a", { href: "https://www.icloud.com/iclouddrive/0dc1MKbkknpFfAndorZ-BBdTA#ThemeShowcase-1" }, "iCloud Drive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                  _createElementVNode("a", { href: "https://1drv.ms/u/c/c6bbfc602e5efcd0/IQBWjyBlxrLWTp5ikzDVOw_zAdb6H5A05w8fVpz5PgxtmeE?e=UMl3hb" }, "OneDrive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                  _createElementVNode("a", { href: "https://drive.google.com/file/d/1GROivf_X95xFE66lOrTHbSZMrHsDM0we/view?usp=share_link" }, "Google Drive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                  _createElementVNode("a", { href: "https://pan.baidu.com/s/12kjAce8f3NxYGxK-OU0alw?pwd=ztzs" }, "百度网盘 (提取码：ztzs)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                  _createElementVNode("a", { href: "https://disk.yandex.ru/d/RFrpDvjxJyQqcg" }, "Яндекс Диск", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                  _createElementVNode("a", { href: "https://www.dropbox.com/scl/fi/5kavzp5397ztug2o9d18a/ThemeShowcase-1.0b2.apk?rlkey=tkbaf8ts5bl5ipol5u3r8sgnk&st=k4u1n12s&dl=0" }, "Dropbox", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                  _createElementVNode("a", { href: "https://app.box.com/s/of7hu7p6hceyk6xvsng7dtorkawthz6y" }, "Box", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                  _createElementVNode("a", { href: "https://drive.proton.me/urls/H82GV8YBPM#Wmre4qOZzODv" }, "Proton Drive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                  _createElementVNode("a", { href: "https://pan.xunlei.com/s/VOrBPeGkXa4i9wv-zl6Bp9utA1?pwd=gjwj" }, "迅雷云盘 (提取码：gjwj)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                  _createElementVNode("a", { href: "https://1024terabox.com/s/1CTwe27O0aBY2Q1asgBBAQw" }, "Terabox", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                  _createElementVNode("a", { href: "https://mega.nz/file/q5wVBKiT#29V11ruNfsvxMc_e8QjDofAtdKJhVaYJdQrxQiInwz8" }, "MEGA", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                  _createElementVNode("a", { href: "https://pan.quark.cn/s/12099dbf747f" }, "夸克网盘", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _cache[47] || (_cache[47] = _createElementVNode("h2", { style: {"padding-left":"30px"} }, "ThemeShowcase 1.0 (Beta 1)", -1)),
                      _createVNode(_component_ion_label, {
                        color: "medium",
                        class: "tableLabel",
                        style: {"padding-left":"30px"}
                      }, {
                        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                          _createTextVNode("SHA256 Checksum: 9bbecb33d577e1dfb26491f456eed75f1658c91a95a74a2c3806b679a1b2ac26", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_list, {
                        inset: true,
                        style: {"border-radius":"25px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                  _createElementVNode("a", { href: "https://f2.puffercat.xyz/PuffercatApps/ThemeShowcase-1.0b.apk" }, "🇩🇪 2.puffercat.xyz - Contabo (Default)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                  _createElementVNode("a", { href: "https://cdn.puffercat.xyz/c/puffercat-apps/apks/ThemeShowcase/ThemeShowcase-1.0b.apk" }, "🇳🇱 puffercat.xyz - DigitalOcean", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                  _createElementVNode("a", { href: "https://deimos.pufferc.at/mirror/ThemeShowcase-1.0b.apk" }, "🇸🇪 deimos.pufferc.at - aeza", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                  _createElementVNode("a", { href: "https://c.wadowice.ovh/index.php/s/themeshowcase1b" }, "🇵🇱 wadowice.ovh - My home (pls dont ddos 🥺)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                  _createElementVNode("a", { href: "https://www.icloud.com/iclouddrive/06esiWCsrhr8f2YHXx0UjIiSA#ThemeShowcase-1" }, "iCloud Drive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                  _createElementVNode("a", { href: "https://1drv.ms/u/c/c6bbfc602e5efcd0/IQDW4qjhuycJSp-4Mqfr11lYAUYO-iEoIbsWlzBB-Pyk-tg?e=aLRQTX" }, "OneDrive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                  _createElementVNode("a", { href: "https://drive.google.com/file/d/1AauWIG6HuEHoVzoDx-g7TsJL1e8ryPch/view?usp=share_link" }, "Google Drive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                  _createElementVNode("a", { href: "https://pan.baidu.com/s/1RGYat1gN9Tr3PALx_uJPMw?pwd=ztzs" }, "百度网盘 (提取码：ztzs)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                  _createElementVNode("a", { href: "https://disk.yandex.ru/d/rkn4wXI5cwk3og" }, "Яндекс Диск", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                  _createElementVNode("a", { href: "https://www.dropbox.com/scl/fi/yvzjcbwpn2p5ko2ni2kph/ThemeShowcase-1.0b.apk?rlkey=mdz2d6srgmkglo071pgy8kewe&st=jy7xgo9w&dl=0" }, "Dropbox", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                  _createElementVNode("a", { href: "https://app.box.com/s/2paombc0rin2fwua6ymrslnl5p6appmn" }, "Box", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                  _createElementVNode("a", { href: "https://drive.proton.me/urls/R31K5G9DCG#30J7GaScLdp2" }, "Proton Drive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                  _createElementVNode("a", { href: "https://pan.xunlei.com/s/VOrBPj5FhnZ2OUODS3GovMCFA1?pwd=zyyc" }, "迅雷云盘 (提取码：zyyc)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                  _createElementVNode("a", { href: "https://1024terabox.com/s/19ttrqa8gnrPAWloC98dtRQ" }, "Terabox", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                  _createElementVNode("a", { href: "https://mega.nz/file/utgCHLZb#30Lo_t_RcJTv1pQOEcMR6A9m-djWK92MOGDzwQ9crUY" }, "MEGA", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                  _createElementVNode("a", { href: "https://pan.quark.cn/s/63945f16a0b7" }, "夸克网盘", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512),
              _createVNode(_component_ion_modal, {
                ref: "modal2",
                trigger: "googlePlayEA_ThemeShowcase"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_title, null, {
                            default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                              _createTextVNode("Google Play Early Access", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dismiss2()))
                              }, {
                                default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                  _createTextVNode("Close", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_content, { class: "ion-padding" }, {
                    default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                      _createElementVNode("p", { class: "guideTextRegular" }, "Due to Google's \"production application\" requirements, this app is not yet able to be published on Google Play. You can join the closed testing program to access the app now and help fulfill the requirements to get fully published.", -1),
                      _createElementVNode("div", { class: "guideNumberBackground" }, "1", -1),
                      _createElementVNode("div", { class: "guideSectionContainer" }, [
                        _createElementVNode("div", { class: "guideSectionLineContainer" }, [
                          _createElementVNode("div", { class: "guideSectionline" })
                        ]),
                        _createElementVNode("div", { class: "guideSectionContent" }, [
                          _createElementVNode("p", { class: "guideTextRegular" }, [
                            _createTextVNode("Join "),
                            _createElementVNode("a", { href: "https://groups.google.com/g/pfrmedia-beta" }, "this"),
                            _createTextVNode(" Google group. Make sure you're using the same Google account as the one you'll download the app on.")
                          ]),
                          _createElementVNode("img", {
                            src: _imports_1,
                            class: "guideImage"
                          })
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "guideNumberBackground" }, "2", -1),
                      _createElementVNode("div", { class: "guideSectionContainer" }, [
                        _createElementVNode("div", { class: "guideSectionLineContainer" }, [
                          _createElementVNode("div", { class: "guideSectionline" })
                        ]),
                        _createElementVNode("div", { class: "guideSectionContent" }, [
                          _createElementVNode("p", { class: "guideTextRegular" }, [
                            _createTextVNode("Go "),
                            _createElementVNode("a", { href: "https://play.google.com/store/apps/details?id=xyz.puffercat.themeshowcase" }, "here"),
                            _createTextVNode(" to download the app. Ensure the account you're using on Google Play is the same one you joined the group on.")
                          ]),
                          _createElementVNode("img", {
                            src: _imports_2,
                            class: "guideImage"
                          })
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "guideNumberBackground" }, "3", -1),
                      _createElementVNode("div", { class: "guideSectionContainer" }, [
                        _createElementVNode("div", { class: "guideSectionLineContainer" }, [
                          _createElementVNode("div", { class: "guideSectionline" })
                        ]),
                        _createElementVNode("div", { class: "guideSectionContent" }, [
                          _createElementVNode("p", { class: "guideTextRegular" }, "Please use the \"Private feedback to developer\" function to help the app get published (Google uses this as a metric of app's production readiness)"),
                          _createElementVNode("img", {
                            src: _imports_3,
                            class: "guideImage"
                          })
                        ])
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Changelog - 1.0 (Beta 2)")
                      ], -1),
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, "Updated target Android version to comply with Google Play requirements"),
                        _createElementVNode("li", null, "First release on Google Play")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Description")
                      ], -1),
                      _createElementVNode("p", null, "ThemeShowcase is an app that allows you to preview all standard themes for XML layouts.", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Screenshots")
                      ], -1),
                      _createElementVNode("div", { class: "scrollScreenshots" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_5,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_7,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_8,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_9,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_10,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_11,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_12,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_13,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_14,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_15,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_16,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_17,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_18,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_19,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_20,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_21,
                          class: "screenshot"
                        })
                      ], -1),
                      _createElementVNode("br", null, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Links")
                      ], -1),
                      _createElementVNode("a", {
                        href: "https://pufferrom.t.me",
                        class: ""
                      }, "Telegram channel (releases)", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://puffercatchannel.t.me",
                        class: ""
                      }, "Telegram channel (general)", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://puffercatrom.t.me",
                        class: ""
                      }, "Support group", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://github.com/KZacharski/ThemeShowcase",
                        class: ""
                      }, "GitHub repo (coming soon)", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}